import React, { useState, useEffect, useRef } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/user_profile.css";
import "../../assets/css/Security.css";
import $ from "jquery";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Security = () => {
	const [disabled, setDisabled] = useState(true);
	const [value, SetValue] = useState("*********");

	useEffect(() => {}, []);
	function handleGameClick() {
		setDisabled(!disabled);
	}
	const stopSubmit = (event) => {
		event.preventDefault();
	};
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-7">
							<Logout />
							{/* Account starts here */}
							<div className="account-form-wrapper">
								<div className="account-heading-wrapper">
									<h3>Security</h3>
								</div>
								<form action="" onSubmit={stopSubmit}>
									<div className="form-group row">
										<div className="col-lg-5">
											<label htmlFor="">Current Password</label>
											<input
												type="text"
												className="form-control"
												placeholder="********"
												disabled={disabled}
											/>
										</div>
										<div className="col-lg-5">
											<label htmlFor="">New Password</label>
											<input
												type="text"
												placeholder="********"
												className="form-control"
												disabled={disabled}
											/>
										</div>
									</div>
									<div className="form-group row">
										<div className="col-lg-5">
											<label htmlFor="">Confirm Password</label>
											<input
												type="text"
												// defaultValue="******"
												className="form-control"
												placeholder="********"
												disabled={disabled}
											/>
										</div>
									</div>
									<div className="form-group">
										<button
											className="btn btn-red"
											type="submit"
											onClick={handleGameClick}
										>
											{disabled ? "Edit Profile" : "Save Changes"}
										</button>
									</div>
								</form>
							</div>
							{/* Account ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default Security;
